import { useMutation, UseMutationResult } from 'react-query'
import { localConfig } from '../../../Configs/localConfig'
import { errorAlert, loadingAlert, successAlert } from '../../../utils/alert'
import { api } from '../../api'

interface PropsDeletarMicrorganismos {
  cod_microrganismos: number
  refetch_deletar: Function
}

export const useDeleteMicrorganismos = (): {
  carregando_deletar_microrganismos: boolean
  mutate_deletar_microrganismos: (params: PropsDeletarMicrorganismos) => void
} => {
  const mutation: UseMutationResult<Response, Error, PropsDeletarMicrorganismos> = useMutation(
    async (params: PropsDeletarMicrorganismos) => {
      const { cod_microrganismos, refetch_deletar } = params

      const config = localConfig()

      loadingAlert({ msg: 'Excluindo...', id: 'delete_microrganismos' })

      return api
        .delete(`recomendacao/microrganismo/${cod_microrganismos}?codConta=${config.conta}`)
        .then((response: any) => {
          successAlert('Excluído com sucesso!', 5000, 'delete_microrganismos')
          refetch_deletar?.()
          return response
        })
        .catch((error: Error) => {
          //@ts-ignore
          let error_response = error?.response?.data
          errorAlert(error_response?.error ?? 'Falha ao excluir fertilizante', 5000, 'delete_microrganismos')

          throw error
        })
    }
  )

  return {
    carregando_deletar_microrganismos: mutation.isLoading,
    mutate_deletar_microrganismos: mutation.mutate,
  }
}
